var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { autoinject } from "aurelia-framework";
import { I18N } from "aurelia-i18n";
import { NotificationClientService } from "../../../../../services/basics/notification-client.service";
import { DialogClientService } from "../../../../../services/basics/dialog-client.service";
import { BrandRenderLayout } from "../../brand/steps/brand-render-layout";
import { BrandRenderTheme } from "../../brand/steps/brand-render-theme";
import { LotteryKeyHelper, BrandClientService } from "../../../../../services/modules/brand-client.service";
import { LotteryClientService } from "../../../../../services/modules/lottery-client.service";
var LotteryRenderDialog = /** @class */ (function () {
    function LotteryRenderDialog(dialogClientService, i18N, notificationService, brandClientService, lotteryClientService, layout, theme) {
        var _this = this;
        this.dialogClientService = dialogClientService;
        this.i18N = i18N;
        this.brandClientService = brandClientService;
        this.lotteryClientService = lotteryClientService;
        this.layout = layout;
        this.theme = theme;
        this.selectedSection = null;
        this.editText = false;
        this.previewBrandId = null;
        this.previewTemplateName = null;
        this.previewThemeName = null;
        this.previewLotteryId = null;
        this.previewLotteryKey = null;
        this.previewBrandLotteryId = null;
        // True while a right-panel click drives the left selection, so the round-trip doesn't reopen the group.
        this.syncingFromTheme = false;
        this.layout.embeddedPreview = false;
        this.theme.embeddedPreview = false;
        this.layout.onSelect = function (section) { return _this.onLayoutSelect(section); };
        this.theme.onSelectVariant = function (variantId) { return _this.onThemeSelectVariant(variantId); };
        this.theme.layoutSectionsProvider = function () { return _this.layout.layout ? _this.layout.layout.sections : null; };
        this.layout.onLayoutChanged = function () { return _this.theme.refreshColorSections(); };
    }
    LotteryRenderDialog.prototype.activate = function (model) {
        var _this = this;
        this.item = model;
        var nav = model.navigationInfo || {};
        var templateName = model.brandTemplateInternalName;
        var themeName = model.brandThemeInternalName;
        var brandLotteries = model.brandLotteries || [];
        var brandLottery = brandLotteries.filter(function (x) { return x.lotteryId === model.lotteryId
            && (!nav.brandId || x.brandId === nav.brandId); })[0] || brandLotteries[0];
        var brandLotteryId = brandLottery ? brandLottery.brandLotteryId : null;
        this.adapterItem = { brandId: nav.brandId, activeBrandLotteries: nav.brandLotteries || [], brandLanguages: nav.brandLanguages || [] };
        // "Copy from another lottery": the brand's other lotteries (exclude this one). Loaded async via the
        // same service the branding editors use, since a LotteryModel's navigationInfo carries no lottery list.
        // keyPrefix/itemKeyPrefix re-prefix item-scoped text/image keys from the source lottery slug to this one.
        this.theme.itemKeyPrefix = LotteryKeyHelper.getKey(model.name);
        if (nav.brandId)
            this.lotteryClientService.getLotteriesByBrand(nav.brandId).then(function (lotteries) {
                _this.theme.copyCandidates = (lotteries || [])
                    .filter(function (x) { return x.brandLotteryId && x.brandLotteryId !== brandLotteryId; })
                    .map(function (x) {
                    var name = (x.lottery && x.lottery.name) || ("#" + x.brandLotteryId);
                    return { key: "l" + x.brandLotteryId, label: name, keyPrefix: LotteryKeyHelper.getKey(name), brandLotteryId: x.brandLotteryId };
                });
            }).catch(function () { });
        this.layout.brandLotteryId = this.theme.brandLotteryId = brandLotteryId;
        this.layout.overrideBrandId = this.theme.overrideBrandId = nav.brandId;
        this.layout.overrideTemplateName = this.theme.overrideTemplateName = templateName;
        this.previewBrandId = nav.brandId;
        this.previewTemplateName = templateName;
        this.previewThemeName = themeName;
        this.previewLotteryId = model.lotteryId;
        this.previewLotteryKey = LotteryKeyHelper.getKey(model.name);
        this.previewBrandLotteryId = brandLotteryId;
        this.resolveCapabilities(model, nav, brandLottery);
    };
    LotteryRenderDialog.prototype.resolveCapabilities = function (model, nav, brandLottery) {
        var _this = this;
        var caps = {};
        if (nav.canCreateSyndicates === false)
            caps.syndicate = false;
        else if (brandLottery && Array.isArray(brandLottery.syndicates))
            caps.syndicate = brandLottery.syndicates.length > 0;
        this.layout.requiredCapabilities = caps;
        if (!nav.brandId)
            return;
        this.brandClientService.getLotteryBrandSubsciptions(nav.brandId, nav.operatorId || null).then(function (response) {
            var configs = (response && response.configs) || [];
            var config = configs.filter(function (c) { return c.lotteryId === model.lotteryId; })[0];
            caps.subscription = !!(config && config.isSubscribed);
            _this.layout.applyCapabilities(Object.assign({}, caps));
        }).catch(function () { });
    };
    LotteryRenderDialog.prototype.attached = function () {
        // Both embedded editors share this one preview for highlight + reload-on-save.
        this.layout.preview = this.preview;
        this.theme.preview = this.preview;
    };
    LotteryRenderDialog.prototype.onLayoutSelect = function (section) {
        this.selectedSection = section;
        if (this.theme && section && !this.syncingFromTheme)
            this.theme.openColorSection(section);
    };
    LotteryRenderDialog.prototype.onThemeSelectVariant = function (variantId) {
        this.syncingFromTheme = true;
        this.layout.selectByVariant(variantId);
        this.syncingFromTheme = false;
    };
    Object.defineProperty(LotteryRenderDialog.prototype, "selectedSectionLabel", {
        get: function () {
            return this.selectedSection ? this.layout.variantLabel(this.selectedSection) : null;
        },
        enumerable: false,
        configurable: true
    });
    LotteryRenderDialog.prototype.onTextEdit = function (key, value) {
        if (this.theme)
            this.theme.applyInlineText(key, value);
    };
    LotteryRenderDialog.prototype.close = function () {
        this.dialogClientService.hide();
    };
    LotteryRenderDialog = __decorate([
        autoinject,
        __metadata("design:paramtypes", [DialogClientService,
            I18N,
            NotificationClientService,
            BrandClientService,
            LotteryClientService,
            BrandRenderLayout,
            BrandRenderTheme])
    ], LotteryRenderDialog);
    return LotteryRenderDialog;
}());
export { LotteryRenderDialog };
